Object.defineProperty(exports,"__esModule",{value:true});var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var



VictorySelectionContainer=function(_VictoryContainer){_inherits(VictorySelectionContainer,_VictoryContainer);function VictorySelectionContainer(){_classCallCheck(this,VictorySelectionContainer);return _possibleConstructorReturn(this,(VictorySelectionContainer.__proto__||Object.getPrototypeOf(VictorySelectionContainer)).apply(this,arguments));}_createClass(VictorySelectionContainer,[{key:"getRect",value:function getRect(


















































































props){var
x1=props.x1,x2=props.x2,y1=props.y1,y2=props.y2,selectionStyle=props.selectionStyle;
var width=Math.abs(x2-x1);
var height=Math.abs(y2-y1);
var x=Math.min(x1,x2);
var y=Math.min(y1,y2);
return y2&&x2&&x1&&y1?
_react2.default.createElement("rect",{x:x,y:y,width:width,height:height,style:selectionStyle}):null;
}},{key:"renderContainer",value:function renderContainer(
props,svgProps,style){var
title=props.title,desc=props.desc,children=props.children,portalComponent=props.portalComponent,className=props.className;
return(
_react2.default.createElement("svg",_extends({},svgProps,{style:style,className:className}),
_react2.default.createElement("title",{id:"title"},title),
_react2.default.createElement("desc",{id:"desc"},desc),
this.getRect(props),
children,
_react2.default.cloneElement(portalComponent,{ref:this.savePortalRef})));


}}]);return VictorySelectionContainer;}(_victoryCore.VictoryContainer);VictorySelectionContainer.displayName="VictorySelectionContainer";VictorySelectionContainer.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{selectionStyle:_react2.default.PropTypes.object,onSelection:_react2.default.PropTypes.func,onSelectionCleared:_react2.default.PropTypes.func});VictorySelectionContainer.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{selectionStyle:{stroke:"black",fill:"black",fillOpacity:0.2}});VictorySelectionContainer.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){evt.preventDefault();var _Selection$getSVGEven=_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x,y=_Selection$getSVGEven.y;if((0,_isFunction3.default)(targetProps.onSelectionCleared)){targetProps.onSelectionCleared();}return[{target:"parent",mutation:function mutation(){return{x1:x,y1:y,select:true,x2:null,y2:null};}},{target:"data",childName:targetProps.children?"all":undefined,eventKey:"all",mutation:function mutation(){return null;}}];},onMouseMove:function onMouseMove(evt,targetProps){if(!targetProps.select){return{};}else{var _ret=function(){var _Selection$getSVGEven2=_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x,y=_Selection$getSVGEven2.y;return{v:{target:"parent",mutation:function mutation(){return{x2:x,y2:y};}}};}();if(typeof _ret==="object")return _ret.v;}},onMouseUp:function onMouseUp(evt,targetProps){var x2=targetProps.x2,y2=targetProps.y2;var parentMutation=[{target:"parent",mutation:function mutation(){return{select:false,x1:null,x2:null,y1:null,y2:null};}}];if(!x2||!y2){return parentMutation;}var bounds=_victoryCore.Selection.getBounds(targetProps);var datasets=_victoryCore.Selection.getDatasets(targetProps);var selectedData=_victoryCore.Selection.filterDatasets(datasets,bounds);var callbackMutation=selectedData&&(0,_isFunction3.default)(targetProps.onSelection)?targetProps.onSelection(selectedData,bounds):{};var dataMutation=selectedData?selectedData.map(function(d){return{childName:d.childName,eventKey:d.eventKey,target:"data",mutation:function mutation(){return(0,_assign3.default)({active:true},callbackMutation);}};}):[];return parentMutation.concat(dataMutation);}}}];exports.default=VictorySelectionContainer;


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-selection-container/victory-selection-container.js
// module id = 1250
// module chunks = 0 1